module.exports = __webpack_public_path__ + "static/media/checkCircle.8a355fd9.svg";